fx.ns("shared.components", class CoverThumb extends fx.DataHandler
{    
        constructor(parameters)
        {
            super(parameters.component);

            this._element = parameters.element;
            this._model = parameters.model;
            this._context = parameters.context;
            this._side = parameters.side;
            this._fontstyle = parameters.fontstyle;
            this._creationSize = parameters.creationSize;

            if (this.model.creation.isBook)
            {
                if (this.element.isCover)
                {
                    if (this.side == "left")
                        this.offset = 0;
                    else
                        this.offset = (this.creationSize.width + this.creationSize.slice);
                }
                else
                {
                    if (this.side == "left")
                        this.offset = 0;
                    else
                        this.offset = this.creationSize.width;
                }
            }
            else
                this.offset =  0;
            
            this.TO_RADIANS = Math.PI/180; 
        }

        get model()
        {
            return this._model;
        }


        get element()
        {
            return this._element;
        }


        get context()
        {
            return this._context;
        }

        get image()
        {
            return this._image;
        }

        get side()
        {
            return this._side;
        }

        get fontstyle()
        {
            return this._fontstyle;
        }

        get creationSize()
        {
            return this._creationSize;
        }

        get elementRotation()
        {
            return this.data.rotation;
        }

        get elementRotationInner()
        {
            return this.data.rotation_inner;
        }

        get elementX()
        {
            return this.data.x * this.creationSize.ratio;
        }

        get elementY()
        {
            return this.data.y * this.creationSize.ratio;
        }

        get elementWidth()
        {
            return this.data.width * this.creationSize.ratio;
        }

        get elementHeight()
        {
            return this.data.height * this.creationSize.ratio;
        }

        get elementXInner()
        {
            if (this.data instanceof models.ThemeLayoutComponent)
                return 0;
            else
                return this.data.x_inner * this.creationSize.ratio;
        }

        get elementYInner()
        {
            if (this.data instanceof models.ThemeLayoutComponent)
                return 0;
            else
                return this.data.y_inner * this.creationSize.ratio;
        }

        get elementWidthInner()
        {
            if (this.data instanceof models.ThemeLayoutComponent)
                return this.data.width * this.creationSize.ratio;
            else
                return this.data.width_inner * this.creationSize.ratio;
        }

        get elementHeightInner()
        {
            if (this.data instanceof models.ThemeLayoutComponent)
                return this.data.height * this.creationSize.ratio;
            else
                return this.data.height_inner * this.creationSize.ratio;
        }

        load()
        {
            this.delay(this.onLoadError, fx.get("settings").coverImageTimeOut);
        }

        loadImage(url)
        {
            this._image = new Image();
            this._image.setAttribute('crossorigin', 'anonymous');
            this._image.src = url;
            
            this.on("load", this.onImageLoaded, this._image);
            this.on("error", this.onLoadError, this._image);
        }

        onImageLoaded(e)
        {
            this.ready();
        }

        onLoadError(e)
        {
            this.ready();
        }

        ready()
        {
            this.delay(this.onLoadError, null);
            this.trigger("ready");
        }
    });
    